import { FuelTypography } from '@frete.com/fuel-react'
import styled from 'styled-components'

export default styled(FuelTypography).attrs({ size: 'caption', weight: 'bold' })`
  margin-bottom: ${({ theme }) => theme.spacing.km1};
  display: block;
`
